import { ITag } from "services/types";
import { TagLink } from "./TagLink";

import "./styles.scss";

export const TagList = (props: {
  tags: ITag[];
  counts: boolean;
}): JSX.Element => {
  const tags = props.tags.filter(tag => !!tag.name);

  return (
    <div className="tagList">
      {tags.map((tag: ITag, index: number) => (
        <TagLink tag={tag} key={tag.name} counts={props.counts} />
      ))}
    </div>
  );
};
